import tinycolor from 'tinycolor2';

export const getRandomTagColour = () => {
  const randomSeed = Math.random() * 360;
  // use initial starting colour at 100% saturation and 85% lightness
  const c = tinycolor('hsl(0, 100%, 85%)').spin(randomSeed);
  return c.toHexString();
};
